"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import { YellowSideMenuItem } from "@/@types/ui/YellowSideMenu";

// Props
type Props = {
  menuItems: YellowSideMenuItem[];
  activeItem: string;
  activeSubItem?: string; // Slug del subítem activo
};

export default function YellowSideMenu({
  menuItems,
  activeItem,
  activeSubItem,
}: Props) {
  const [openItemIndex, setOpenItemIndex] = useState<number | null>(null);

  useEffect(() => {
    const parentIndex = menuItems.findIndex(
      (item) =>
        item.id === activeItem ||
        item.children?.some((child) => child.id === activeSubItem)
    );
    setOpenItemIndex(parentIndex !== -1 ? parentIndex : null);
  }, [activeItem, activeSubItem, menuItems]);


  return (
    <aside className="bg-white border border-gray-200 rounded-md shadow">
      <ul className="divide-y divide-gray-200">
        {menuItems.map((item, index) => (
          <li key={item.id} className="group">
            {/* Encabezado del acordeón */}
            <div
              className={`flex justify-between items-center w-full ${activeItem === item.id ? "bg-yellow-400" : "bg-[#f5f5f5]"
                } hover:bg-gray-200`}
            >
              {/* Título con enlace */}
              {item.href ? (
                <Link
                  href={item.href}
                  className={`block py-4 px-4 font-bold text-lg uppercase flex-1 ${activeItem === item.id ? "text-black" : "text-gray-800"
                    }`}
                >
                  {item.title}
                </Link>
              ) : (
                <span
                  className={`block py-4 px-4 font-bold text-lg uppercase flex-1 ${activeItem === item.id ? "text-black" : "text-gray-800"
                    }`}
                >
                  {item.title}
                </span>
              )}

              {/* Flecha para el acordeón */}
              <button
                onClick={() =>
                  setOpenItemIndex(index === openItemIndex ? null : index)
                }
                className="p-4"
              >
                {openItemIndex === index ? (
                  <ChevronDownIcon className="h-6 w-6 text-black" />
                ) : (
                  <ChevronRightIcon className="h-6 w-6 text-black" />
                )}
              </button>
            </div>

            {/* Contenido del acordeón: hijos */}
            {openItemIndex === index && item.children && (
              <ul className="divide-y divide-gray-200">
                {item.children.map((child) => (
                  <li key={child.id} className="py-2">
                    <div className="pl-8">
                      {child.href ? (
                        <Link
                          href={child.href}
                          className={`block ${activeSubItem === child.id
                              ? "text-yellow-500 "
                              : "text-gray-800"
                            } hover:text-yellow-500`}
                        >
                          {child.title}
                        </Link>
                      ) : (
                        <span
                          className={`block ${activeSubItem === child.id
                              ? "text-yellow-500 "
                              : "text-gray-800"
                            }`}
                        >
                          {child.title}
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}
